export const iconFontAwesomeEmojiFaceMehBlank = (
	<i className="fa-solid fa-face-meh-blank"></i>
);
